// extracted by mini-css-extract-plugin
export var completionBody = "_lf-2";
export var completionCard = "_lf-0";
export var completionFooter = "_lf-3";
export var completionTitle = "_lf-1";